import {
  getMiddleware,
  guardNames,
  navigationNames,
} from '@booking-portal/router/router-constants';
import type { RouteRecordRaw } from 'vue-router';

export const customerPortalRootPath = '/customer-portal';

export const customerPortalRoutes: RouteRecordRaw[] = [
  {
    path: `${customerPortalRootPath}/redirect`,
    children: [
      {
        name: navigationNames.redirectIdCheck,
        path: 'id-check',
        component: () =>
          import('@booking-portal/modules/customer-portal/pages/CustomerPortalRedirectIdCheckPage.vue'),
      },
    ],
  },
  {
    path: customerPortalRootPath,
    meta: {
      ...getMiddleware([guardNames.authenticatedGuard]),
    },
    component: () =>
      import('@booking-portal/modules/customer-portal/layouts/CustomerPortalLayout.vue'),
    children: [
      {
        path: 'account-overview',
        component: () =>
          import('@booking-portal/modules/customer-portal/pages/CustomerPortalAccountOverviewPage.vue'),
        children: [
          {
            name: navigationNames.accountOverview,
            path: ':locationId?',
            component: () =>
              import('@booking-portal/modules/customer-portal/pages/CustomerPortalAccountOverviewLocationPage.vue'),
          },
        ],
      },
      {
        name: navigationNames.customerPortalUpdatePaymentMethod,
        path: 'account-overview/:locationId/payment/update',
        component: () =>
          import('@booking-portal/modules/customer-portal/pages/CustomerPortalUpdatePaymentPage.vue'),
      },
      {
        name: navigationNames.customerPortalUpdatePaymentMethodVerify,
        path: 'account-overview/:locationId/payment/update/verify',
        component: () =>
          import('@booking-portal/modules/customer-portal/pages/CustomerPortalUpdatePaymentVerifyPage.vue'),
      },
      {
        name: navigationNames.customerPortalSharedAccess,
        path: 'account-overview/:locationId/shared-access',
        meta: {
          ...getMiddleware([guardNames.hasSharedAccess]),
        },
        component: () =>
          import('@booking-portal/modules/customer-portal/pages/CustomerPortalSharedAccessPage.vue'),
      },
    ],
    redirect: `${customerPortalRootPath}/account-overview`,
  },
];
